import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { productGroups, megaMenuProducts } from "../../mock";
import { getProductName } from "../../utils/translator";

const MegaMenu = ({ lang, onMouseEnter, onMouseLeave, onClose }) => {
    const [activeCategory, setActiveCategory] = useState(productGroups[0]?.slug);
    const menuRef = useRef(null);

    const currentProducts = megaMenuProducts[activeCategory] || [];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    return (
        <div
            ref={menuRef}
            className="absolute top-full left-0 right-0 bg-white shadow-2xl border-t border-black/5 animate-in fade-in slide-in-from-top-2 duration-300 z-50 overflow-hidden"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="mx-auto flex max-w-6xl min-h-[500px]">
                {/* Left Sidebar: Categories */}
                <div className="w-[300px] border-r border-black/5 bg-white overflow-y-auto max-h-[70vh]">
                    <div className="flex flex-col">
                        {productGroups.map((group) => (
                            <Link
                                key={group.slug}
                                to={`/products/${group.slug}`}
                                onMouseEnter={() => setActiveCategory(group.slug)}
                                onClick={onClose}
                                className={`px-8 py-3.5 text-left transition-all duration-200 border-b border-black/5 last:border-b-0 block ${activeCategory === group.slug
                                    ? "bg-primary/5 text-primary border-l-4 border-l-primary"
                                    : "text-gray-800 hover:bg-gray-50 border-l-4 border-l-transparent"
                                    }`}
                            >
                                <span className="text-[13px] font-bold uppercase tracking-[0.1em]">
                                    {group[`title_${lang}`]}
                                </span>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* Right Content: Products Grid */}
                <div className="flex-1 bg-white p-10 overflow-y-auto max-h-[70vh]">
                    <div className="grid grid-cols-3 gap-6">
                        {currentProducts.map((product) => (
                            <Link
                                key={product.id}
                                to={product.slug ? `/products/${activeCategory}/${product.slug}` : `/products/${activeCategory}`}
                                className="group relative block aspect-square w-full overflow-hidden bg-white rounded-lg border border-gray-100 shadow-[0_3px_10px_rgb(0,0,0,0.06)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all duration-300"
                                onClick={onClose}
                            >
                                <img
                                    src={product.imageUrl}
                                    alt={getProductName(product, lang)}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-black/60 backdrop-blur-[2px] py-3 text-center border-t border-white/10 transition-colors group-hover:bg-primary/90">
                                    <h4 className="text-[12px] font-bold tracking-widest text-white uppercase px-2 line-clamp-1">
                                        {getProductName(product, lang)}
                                    </h4>
                                </div>
                            </Link>
                        ))}
                        {currentProducts.length === 0 && (
                            <div className="col-span-3 flex flex-col items-center justify-center h-64 text-gray-400 space-y-4">
                                <div className="w-12 h-1 bg-gray-100 rounded-full"></div>
                                <p className="text-sm italic">
                                    {lang === "tr" ? "Bu kategoride ürün bulunamadı." : "No products found in this category."}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MegaMenu;
